import { render } from "./ScoreElement.vue?vue&type=template&id=1c02da39&scoped=true"
import script from "./ScoreElement.vue?vue&type=script&lang=js"
export * from "./ScoreElement.vue?vue&type=script&lang=js"

import "./ScoreElement.vue?vue&type=style&index=0&id=1c02da39&lang=scss&scoped=true"

import exportComponent from "/Users/josiahsprankle/Desktop/personal/JDS-Music-Site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c02da39"]])

export default __exports__